import { INICIALIZAR } from '../actions';
export default function configBotones() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configBotones;

    default:
      return state;
  }
}